var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0C14.4875 0 0 12.2729 0 31.254C0 43.3744 9.34063 57.6293 27.9838 74.0567C29.4325 75.3144 31.6056 75.3144 33.0544 74.0567C51.6594 57.6293 61 43.3744 61 31.254C61 12.2729 46.5125 0 30.5 0ZM30.5 38.1146C26.3062 38.1146 22.875 34.6843 22.875 30.4917C22.875 26.2991 26.3062 22.8688 30.5 22.8688C34.6937 22.8688 38.125 26.2991 38.125 30.4917C38.125 34.6843 34.6937 38.1146 30.5 38.1146Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/Ic_location.38af4504cbbd249948c827cb7738f3a4.svg";
export { ForwardRef as ReactComponent };